<script>

import CircleButton from "@/components/Common/Buttons/CircleButton.vue";
import {defineComponent} from 'vue'
import 'vue3-carousel/dist/carousel.css'

export default defineComponent({
  name: 'IndexAboutComponent',
  components: {CircleButton},
  props: {
    title1: {
      type: String
    },
    title2: {
      type: String
    },
    description1: {
      type: String
    },
    description2: {
      type: String
    },
    buttonPlaceholder1: {
      type: String
    },
    buttonPlaceholder2: {
      type: String
    },
    specialists: {
      type: Array
    }
  },
  data: () => ({
    // carousel settings
    settings: {
      itemsToShow: 1.3,
      snapAlign: 'start',
    },
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    breakpoints: {
      // 700px and up
      700: {
        itemsToShow: 3.5,
        snapAlign: 'start',
      },
      // 1024 and up
      1024: {
        itemsToShow: 2.8,
        snapAlign: 'start',
      },
    },
  }),
})
</script>

<template>

  <div class="position-relative ">
    <div class="index-about-wrapper ">
      <div class="row d-md-flex g-0">
        <div class="col-md-6 col-12 d-none d-md-flex">
          <slot name="logo-left"></slot>
        </div>
        <div class="col-md-6 col-12 right-info">
          <div class="index-about-title">{{ title1 }}</div>
          <div class="index-about-description">{{ description1 }}</div>
          <div class="d-flex align-items-center align-self-end ">
            <div class="ms-auto index-about-subtitle me-3">{{ buttonPlaceholder1 }}</div>
            <div>
              <router-link :to="{name: 'AboutUsView' }">
                <CircleButton :theme="'solid-white'"/>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.index-about-wrapper {
  background: $color-cta-main;
  color: $color-white;
  padding: $spacing-9 20px;

  .index-about-title {
    font-size: $title-h4;
    line-height: $title-h4;
  }

  .index-about-description {
    margin-top: $spacing-2;
    font-size: $paragraph-2;
  }

  .index-about-subtitle {
    font-size: $subtitle-1;
    width: 40%;
    line-height: 20px;
    text-align: right;
  }
}

@media screen and (min-width: 768px) {

  .index-about-wrapper {
    padding: 150px 0 0 0;
    border-bottom: 1px solid #fff;

    .index-about-title {
      font-size: $title-h1;
      width: 100%;
      line-height: 40px;
    }

    .index-about-description {
      font-size: $paragraph-1;
      line-height: $paragraph_1;
      width: 80%;
    }

    .index-about-subtitle {
      width: 20%;
    }
  }
  .right-info {
    padding-right: 50px;
  }
}

</style>